import React from 'react';

interface SimilarWebIconProps extends React.SVGAttributes<SVGElement> {
  size?: number;
}

export const SimilarWebLogo: React.FC<SimilarWebIconProps> = ({
  size = 24,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      viewBox="22.109 0.68 20 20"
      {...props}
    >
      <path
        fill="#FF9700"
        d="M36.138 1.845a12.562 12.562 0 0 0-.557-.183c-3.06-.906-4.762.578-5.214 2.11-.62 2.093.437 3.526 3.174 5.636 3.356 2.584 4.746 4.985 3.772 8.278a6.525 6.525 0 0 1-1.425 2.571 9.972 9.972 0 0 0 5.815-6.42c1.447-4.885-1.015-9.997-5.565-11.992z"
      />
      <path
        fill="#2B3D52"
        d="M31.38 11.336c-3.272-2.375-4.972-4.942-4.039-8.098.14-.468.325-.903.553-1.304a9.976 9.976 0 0 0-5.371 6.229 9.983 9.983 0 0 0 1.314 8.456c1.119 1.368 2.202 2.396 4.401 3.003 2.977.822 5.377-.32 6.046-2.581.621-2.094-.221-3.643-2.904-5.705z"
      />
    </svg>
  );
};
